import { RadioGroupItem } from '@zep-us/zus';

// Figma: 24×24 컨테이너(padding 2px = 중앙정렬) 안에 20×20 라디오 아이콘.
// 빌드된 ZUS RadioGroupItem 기본이 16px(h-4 w-4)라 여기서 명시 오버라이드한다.
const RADIO_WRAP = 'flex h-6 w-6 shrink-0 items-center justify-center';
const RADIO_ICON = 'h-5 w-5 shrink-0';

/** 요금제 유형 라디오 한 줄 — 라디오 + 제목(+할인 뱃지) + 설명 (Figma Option Toggle). */
export function PlanTypeOption({
  value,
  title,
  badge,
  description
}: {
  value: string;
  title: string;
  badge?: string;
  description?: string;
}) {
  return <label className="flex cursor-pointer items-start gap-sm" data-sentry-component="PlanTypeOption" data-sentry-source-file="PlanTypeOption.tsx">
      <span className={RADIO_WRAP}>
        <RadioGroupItem value={value} className={RADIO_ICON} data-sentry-element="RadioGroupItem" data-sentry-source-file="PlanTypeOption.tsx" />
      </span>
      <div className="flex flex-col gap-4xs">
        <span className="flex items-center gap-2xs">
          <span className="text-body-lg-bold text-default">{title}</span>
          {badge ? <span className="text-caption-md-medium text-pink-400">
              {badge}
            </span> : null}
        </span>
        {description ? <span className="text-body-sm-medium text-alternative">
            {description}
          </span> : null}
      </div>
    </label>;
}